import axios from "axios";

export class LoginFunction {

  ErrorValidationConstant = "Please enter valid Email or Password";

  async Login(
    body,
    setvalidation,
    setToastConfig,
    toastConfig,
    rememberMe,
    Cookies,
    navigation,
    setLoading
  ) {
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/v1/user/login`, body)
      .then((val) => {
        setLoading(false);
        if (val?.data?.success) {
          localStorage.setItem("Token", val?.data?.result?.token);
          localStorage.setItem("RefreshToken", val?.data?.result?.refreshToken);

          // {
          //   rememberMe && Cookies.set("username", body?.email);
          // }
          // {
          //   rememberMe && Cookies.set("password", body?.password);
          // }
          if (rememberMe) {
            Cookies.set("username", body?.email);
            Cookies.set("password", body?.password);
          }
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Login successfully!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "success",
              message: "Login successfully!",
            });
          }, 1800);
          navigation("/");
        } else {
          setvalidation(this.ErrorValidationConstant);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (
          err?.response?.data?.status_code === "404" ||
          err?.response?.data?.message === "Not Found"
        ) {
          setvalidation(this.ErrorValidationConstant);
        }
        if (
          err?.response?.statusText === "Unauthorized" ||
          err?.response?.status === "401"
        ) {
          setvalidation(this.ErrorValidationConstant);
        }

        if (!err.response) {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "error",
            message: "Network Error!",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              type: "error",
              message: "Network Error!",
            });
          }, 1800);
        }
      });
  }
}
